import React, { PureComponent } from 'react'
import { Button, FormCheck, Collapse, Alert } from 'react-bootstrap'

class HitListItem extends PureComponent {
  constructor(props) {
    super(props)
    let media = []
    let image = ''
    let links = []

    if (this.props.data.doc !== null) {
      const { doc } = this.props.data
      const keys = Object.keys(doc)
      if (keys.includes('media')) {
        doc.media.map((hit) => {
          const obj = { url: hit.url, snippet: hit.snippet, title: hit.title }
          media.push(obj)
          return null
        })
      }
      if (keys.includes('assets')) {
        doc.assets.map((asset) => {
          if (asset.type === 'picture') {
            image = asset.public_url
          }
          return null
        })
      }
      if (keys.includes('fields')) {
        doc.fields.map((field) => {
          if (field.name === 'Related Url') {
            links.push(field.value)
          }
          return null
        })
      }
    }
    this.state = {
      open: false,
      allChecked: false,
      image: image,
      media: media,
      links: links,
    }
  }

  collapseSection = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  confirm = (event) => {
    this.setState({
      allChecked: event.target.checked,
    })
    this.props.confirm(event)
  }

  sendLink = () => {
    const url = this.props.url.replace('search', 'entity')
    window.open(url + '/' + this.props.data.doc.id, '_blank')
  }

  makeLink = (link) => {
    return link.slice(0, 70) + '...'
  }

  makeSnippet = (snippet) => {
    return snippet.slice(0, 200) + '...'
  }

  navTo = (link) => {
    window.open(link)
  }

  render() {
    const { props } = this
    const { data, shareURL } = props
    const types = data.doc.types.join(' ')
    const chevronClass = this.state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    return (
      <tr style={{ width: '100%', backgroundImage: 'linear-gradient(to bottom, white, #e7eaec)' }}>
        <td>
          <div style={{ width: '90%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <div
              onClick={this.collapseSection}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                cursor: 'pointer',
                height: '100%',
              }}
            >
              {data.doc.name}
              <i style={{ paddingLeft: 10, width: '10px' }} className={chevronClass} />
            </div>
          </div>
          <Collapse in={this.state.open}>
            <div style={{ paddingTop: 5 }}>
              <Alert
                variant={'secondary'}
                className='section-shadow'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  backgroundImage: 'linear-gradient(to bottom, white, #e7eaec50)',
                  maxHeight: 340,
                }}
                size={'lg'}
              >
                <div style={{ paddingTop: 5, maxWidth: 215 }}>
                  <div>{shareURL}</div>
                  <div style={{ height: 60 }}>
                    <Button className='section-shadow' bsPrefix='btn btn-w-m btn-default' onClick={this.sendLink}>
                      External Link to More Data
                    </Button>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <i
                      style={{
                        width: 20,
                        minHeight: 30,
                        marginRight: 10,
                        color: this.props.media ? '#ed5565' : '#f8ac59',
                      }}
                      className='fa fa-exclamation-triangle'
                    />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>Matched: {types}</div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <i
                      style={{ width: 20, minHeight: 30, marginRight: 10, color: '#1ab394' }}
                      className='fa fa-info-circle'
                    />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>Relevance: {data.match_types[0]}</div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <i style={{ width: 20, minHeight: 30, marginRight: 10, color: '#557491' }} className='fa fa-user' />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>Type: {data.doc.entity_type}</div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <i
                      style={{ width: 20, minHeight: 30, marginRight: 10, color: 'grey' }}
                      className='fa fa-list-alt'
                    />
                    <div style={{ fontWeight: 'bold', minHeight: 30 }}>
                      Match found on {data.doc.sources.length} list
                    </div>
                  </div>
                </div>
                {this.state.image && (
                  <div style={{ paddingLeft: 8, width: 150 }}>
                    <img className='shadow' style={{ maxHeight: 186 }} src={this.state.image} alt='' />
                  </div>
                )}
                {(this.state.links.length > 0 || this.state.media.length > 0) && (
                  <div
                    className='section-shadow'
                    style={{
                      marginLeft: 13,
                      backgroundColor: 'white',
                      borderColor: '#e7eaec',
                      borderWidth: 0.5,
                      borderStyle: 'solid',
                      borderRadius: 5,
                      paddingLeft: 5,
                      paddingRight: 5,
                      width: 500,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div style={{ overflowY: 'scroll', overflowX: 'hidden' }}>
                      {this.state.links.map((link, i) => {
                        return (
                          <span style={{ height: 40, paddingTop: 5 }} onClick={() => this.navTo(link)} key={i}>
                            {this.makeLink(link)}
                            <Button
                              className='shadow'
                              style={{ height: 30, width: 75 }}
                              onClick={() => this.navTo(link)}
                            >
                              Link
                            </Button>
                          </span>
                        )
                      })}
                      {this.state.media.map((hit, i) => (
                        <span style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }} key={i}>
                          <div style={{ fontWeight: 'bold' }}>{hit.title}</div>
                          <div>{this.makeSnippet(hit.snippet)}</div>
                          <div>
                            <Button
                              className='shadow'
                              style={{ height: 30, width: 75 }}
                              onClick={() => this.navTo(hit.url)}
                            >
                              Link
                            </Button>
                          </div>
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </Alert>
            </div>
          </Collapse>
        </td>
        <td style={{ width: '10%' }}>
          <FormCheck
            defaultChecked={props.checked}
            value={this.state.allChecked}
            onClick={this.confirm}
            onChange={this.handleChange}
          />
        </td>
      </tr>
    )
  }
}

export default HitListItem
